if (!customElements.get("shop-by-category")) {
  customElements.define(
    "shop-by-category",
    class ShopByCategory extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.onTabClick = this.onTabClick.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener("click", this.onTabClick);
        });
      }

      onTabClick(event) {
        const tab = event.currentTarget;
        const index = Number(tab.dataset.index);

        this.tabs.forEach((t, i) => {
          const selected = i === index;
          t.setAttribute("aria-selected", selected ? "true" : "false");
        });

        this.panels.forEach((panel, i) => {
          if (i === index) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "");
          }
        });
      }
    }
  );
}


document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 768) return;

  document.querySelectorAll('.shop-by-category__panels .product-grid').forEach(function (slider) {
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let hasDragged = false;

    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      hasDragged = false;
      slider.classList.add('is-dragging');

      startX = e.clientX;
      startScrollLeft = slider.scrollLeft;

      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDown) return;

      const dx = e.clientX - startX;
      if (Math.abs(dx) > 3) {
        hasDragged = true;
      }

      slider.scrollLeft = startScrollLeft - dx;
    });

    document.addEventListener('mouseup', function () {
      isDown = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  });
});